$(document).ready(function() {
    if (typeof brandCarouselBrandName !== 'undefined' && 
        typeof brandCarouselVehicleType !== 'undefined' &&
        typeof brandCarouselItems !== 'undefined') {
        
        populateBrandCarousel(brandCarouselItems);
    }

    // Navigation items (left and right arrow)
    var previous = $('.tire_carousel .jcarousel-control-prev');
    var next = $('.tire_carousel .jcarousel-control-next');

    previous.on('jcarouselcontrol:active', function() {
            $(this).removeClass('inactive');
        })
        .on('jcarouselcontrol:inactive', function() {
            $(this).addClass('inactive');
        })
        .jcarouselControl({
            target: '-=1'
        });

    next.on('jcarouselcontrol:active', function() {
            $(this).removeClass('inactive');
        })
        .on('jcarouselcontrol:inactive', function() {
            $(this).addClass('inactive');
        })
        .jcarouselControl({
            target: '+=1'
        });
});

function populateBrandCarousel(brandCarouselProducts) {
    const carouselWidth = document.getElementById('brandPageCarousel').clientWidth;
    const buttonText = document.getElementById('brandCarouselDetailsButtonText').value;
    const itemsPerPage = window.innerWidth < 768 ? 1 : 4;

    var carouselContainer = $('#brandPageCarousel ul');
    carouselContainer.empty();

    var totalItems = brandCarouselProducts.length;
    var numLists = Math.ceil(totalItems / itemsPerPage);

    for (var i = 0; i < numLists; i++) {
        var listHtml = '<li></li>';
        var listElement = $(listHtml);
        listElement.css('width', carouselWidth + 'px');

        var startIdx = i * itemsPerPage;
        var endIdx = Math.min(startIdx + itemsPerPage, totalItems);

        for (var j = startIdx; j < endIdx; j++) {
            var carouselItemHtml = generateBrandCarouselProductHtml(brandCarouselProducts[j], buttonText, itemsPerPage);
            listElement.append(carouselItemHtml);
        }
        carouselContainer.append(listElement);
    }
    $('#brandPageCarousel').jcarousel();
}

function generateBrandCarouselProductHtml(item, buttonText, itemsPerPage) {
    var itemColumnClass = itemsPerPage === 1 ? 'col-xs-12' : 'col-lg-3 col-md-3 col-sm-3 col-xs-6';
    var carouselItemHtml = '<div class="' + itemColumnClass + ' fl_item">';
    carouselItemHtml += '<a href="/product/' + item.code + '" onclick="ga360BrandProductDetailsClick('+"'" + item.code + "'"+ ")" + '">';
    carouselItemHtml += '<div class="fl_carousel_image">';
    carouselItemHtml += '<img loading="lazy" src="' + item.imageLinkMedium + '" alt="' + item.brandName + ' ' + item.name + '">';
    carouselItemHtml += '</div>';
    carouselItemHtml += '<div class="fl_carousel_caption">';
    carouselItemHtml += '<div class="tire_carousel_logo">';
    carouselItemHtml += '<img loading="lazy" src="' + item.brandImageUrl + '" alt="' + item.brandName + '">';
    carouselItemHtml += '</div>';
    carouselItemHtml += '<div class="tire_carousel_product">';
    carouselItemHtml += '<b>' + item.name + '</b><br>' + item.fullSize + '&nbsp;<b>' + item.priceFormatted + '</b>';
    carouselItemHtml += '</div>';
    carouselItemHtml += '</div>';
    carouselItemHtml += '<span class="pure-button">' + buttonText + '</span>';
    carouselItemHtml += '</a>';
    carouselItemHtml += '</div>';
    return carouselItemHtml;
}

function ga360BrandProductDetailsClick(productCode) {
    var list = "BrandPage";
    var productData = ga360BrandGetProductData(productCode);
    var eventPayload = {
        event: "EECproductClick",
        ecommerce: {
            currencyCode: window.pageData.siteCurrency,
            click: {
                actionField: { list: list },
                products: productData
            }
        }
    };
    dataLayer360.push(eventPayload);
}

function ga360BrandGetProductData(productCode) {
    for (var i = 0; i < brandCarouselItems.length; i++) {
        if (brandCarouselItems[i].code == productCode) {
            return generateBrandData(brandCarouselItems[i], i + 1);
        }
    }
    return '';
}

function generateBrandData(data, position) {
    return {
        category: "Brand : TyreProduct",
        list: "BrandPage",
        id: data.code,
        brand: data.brandName,
        name: data.name,
        variant: data.fullSize,
        price: validateDecimals(window.pageData.languageTag) ?
            data.priceValue.toFixed(2) :
            data.priceValue.toFixed(0),
        position: position,
        dimension60: "Car Tyre",
        dimension61: data.clientReviewsRating,
        dimension62: getBrandStockLevel(data.deltiStock),
        dimension63: data.deltiStock,
        dimension64: data.code,
        dimension65: data.newFlag,
        dimension67: data.speedRating,
        dimension68: data.sprit + " | " + data.nass + " | " + data.sound1 + " dB"
    };
}

function validateDecimals(data) {
    if (data.includes("PL") ||
        data.includes("DK") ||
        data.includes("NO") ||
        data.includes("SE") ||
        data.includes("HU") ) {
            return false;
        }
    return true;
}

function getBrandStockLevel(inStockLevel) {
    var inStockLevelLimit = $('#brandInStockLevelLimit').val();

    if (inStockLevel == 0) {
        return "Out of stock";
    } else if (inStockLevel < inStockLevelLimit) {
        return "Limited stock";
    } else if (inStockLevel >= inStockLevelLimit) {
        return "In stock";
    }
}
